import { WebAssetOutlined, TextFieldsOutlined, SmartButtonOutlined, ImageOutlined, DesktopWindowsOutlined, TabletOutlined, PhoneIphoneOutlined, TimerOutlined, PeopleOutlined, EventNoteOutlined } from '@mui/icons-material';

export const PRIMARY         = '#1075BA';
export const CONTAINER_COLOR = '#8b4fcc';
export const COUNTDOWN_COLOR = '#0ea5e9';
export const SPEAKERS_COLOR   = '#7c3aed';
export const SCHEDULE_COLOR    = '#0f766e';

export const ELEMENT_TYPES = {
  container: {
    label: 'Container', icon: <WebAssetOutlined sx={{ fontSize: 18 }} />, color: CONTAINER_COLOR, sub: 'Layout wrapper',
    defaultData: { type: 'container', orientation: 'column', children: [], style: { padding: '5px', background: 'transparent', borderRadius: '8px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch', alignSelf: 'stretch' } },
  },
  text: {
    label: 'Text', icon: <TextFieldsOutlined sx={{ fontSize: 18 }} />, color: PRIMARY, sub: 'Inline editable',
    defaultData: { type: 'text', content: 'Click to edit text', style: { fontSize: '16px', color: '#1a1a2e', fontWeight: '400' } },
  },
  button: {
    label: 'Button', icon: <SmartButtonOutlined sx={{ fontSize: 18 }} />, color: '#00a882', sub: 'With link',
    defaultData: { type: 'button', label: 'Click Me', href: '#', style: { background: PRIMARY, color: '#fff', borderRadius: '8px', padding: '10px 24px', fontSize: '14px', fontWeight: '700' } },
  },
  image: {
    label: 'Image', icon: <ImageOutlined sx={{ fontSize: 18 }} />, color: '#e67e22', sub: 'URL or upload',
    defaultData: { type: 'image', src: '', alt: '', style: { width: '100%', height: 'auto', borderRadius: '4px', display: 'block' } },
  },
  speakers: {
    label: 'Speakers', icon: <PeopleOutlined sx={{ fontSize: 18 }} />, color: '#7c3aed', sub: 'From event data',
    group: 'Interactive',
    defaultData: {
      type: 'speakers',
      displayMode: 'carousel',   // 'carousel' | 'grid'
      template: 1,               // 1 | 2 | 3
      perSlide: 4,               // carousel: 1–10
      columns: 4,                // grid columns
      gridJustify: 'center',     // 'flex-start' | 'center' | 'flex-end'
      gap: '16px',
      nameColor: '#1a1a2e',
      titleColor: '#5a6474',
      nameFontSize: '15px',
      titleFontSize: '13px',
      style: {},
    },
  },
  schedule: {
    label: 'Schedule', icon: <EventNoteOutlined sx={{ fontSize: 18 }} />, color: '#0f766e', sub: 'From event data',
    group: 'Interactive',
    defaultData: {
      type: 'schedule',
      timeColor: '#1075BA',
      dateColor: '#6b7280',
      titleColor: '#1a1a2e',
      descColor: '#5a6474',
      dividerColor: '#f0f4f8',
      timeFontSize: '22px',
      titleFontSize: '16px',
      descFontSize: '13px',
      showSpeakers: true,
      style: {},
    },
  },
  countdown: {
    label: 'Countdown', icon: <TimerOutlined sx={{ fontSize: 18 }} />, color: COUNTDOWN_COLOR, sub: 'Event timer',
    group: 'Countdown',
    defaultData: {
      type: 'countdown',
      targetDate: (() => {
        const d = new Date(); d.setDate(d.getDate() + 30);
        return d.toISOString().slice(0, 16);
      })(),
      layout: '2x2',
      show: { days: true, hours: true, mins: true, secs: true },
      numberSize: '48px',
      labelSize: '13px',
      numberColor: '#1a1a2e',
      labelColor: '#7a8494',
      cardBackground: '#f1f5f9',
      cardRadius: '12px',
      cardHeight: '100px',
      style: {},
    },
  },
};

export const BREAKPOINTS = [
  { key: 'desktop', icon: <DesktopWindowsOutlined sx={{ fontSize: 18 }} />, label: 'Desktop', width: '100%' },
  { key: 'tablet',  icon: <TabletOutlined sx={{ fontSize: 18 }} />,          label: 'Tablet',  width: '768px' },
  { key: 'mobile',  icon: <PhoneIphoneOutlined sx={{ fontSize: 18 }} />,     label: 'Mobile',  width: '375px' },
];

export const TYPE_META = {
  container: { icon: <WebAssetOutlined sx={{ fontSize: 13 }} />, color: CONTAINER_COLOR },
  text:      { icon: <TextFieldsOutlined sx={{ fontSize: 13 }} />, color: PRIMARY },
  button:    { icon: <SmartButtonOutlined sx={{ fontSize: 13 }} />, color: '#00a882' },
  image:     { icon: <ImageOutlined sx={{ fontSize: 13 }} />, color: '#e67e22' },
  speakers: {
    label: 'Speakers', icon: <PeopleOutlined sx={{ fontSize: 18 }} />, color: '#7c3aed', sub: 'From event data',
    group: 'Interactive',
    defaultData: {
      type: 'speakers',
      displayMode: 'carousel',   // 'carousel' | 'grid'
      template: 1,               // 1 | 2 | 3
      perSlide: 4,               // carousel: 1–10
      columns: 4,                // grid columns
      gridJustify: 'center',     // 'flex-start' | 'center' | 'flex-end'
      gap: '16px',
      nameColor: '#1a1a2e',
      titleColor: '#5a6474',
      nameFontSize: '15px',
      titleFontSize: '13px',
      style: {},
    },
  },
  schedule: {
    label: 'Schedule', icon: <EventNoteOutlined sx={{ fontSize: 18 }} />, color: '#0f766e', sub: 'From event data',
    group: 'Interactive',
    defaultData: {
      type: 'schedule',
      timeColor: '#1075BA',
      dateColor: '#6b7280',
      titleColor: '#1a1a2e',
      descColor: '#5a6474',
      dividerColor: '#f0f4f8',
      timeFontSize: '22px',
      titleFontSize: '16px',
      descFontSize: '13px',
      showSpeakers: true,
      style: {},
    },
  },
  countdown: { icon: <TimerOutlined sx={{ fontSize: 13 }} />, color: COUNTDOWN_COLOR },
  speakers: { icon: <PeopleOutlined sx={{ fontSize: 13 }} />, color: '#7c3aed' },
};
